import axios from 'axios';
import authHeader from './authHeader';

// IMPORTANT: API path uses 'telemetria' (HU) by design. Do NOT change to 'telemetry' or other variants.
export async function getTelemetryThresholds() {
	const res = await axios.get('/api/settings/telemetria-thresholds', { headers: authHeader() });
  return res.data;
}

// IMPORTANT: Keep 'telemetria' segment consistent across all endpoints.
export async function updateTelemetryThresholds(payload) {
	const body = {
		battery_low_threshold_v: payload?.battery_low_threshold_v != null ? Number(payload.battery_low_threshold_v) : undefined,
		fill_green_threshold_pct: payload?.fill_green_threshold_pct != null ? Number(payload.fill_green_threshold_pct) : undefined,
		fill_red_threshold_pct: payload?.fill_red_threshold_pct != null ? Number(payload.fill_red_threshold_pct) : undefined,
	};
	const res = await axios.put(
		'/api/settings/telemetria-thresholds',
		body,
		{ headers: { ...authHeader(), 'Content-Type': 'application/json' } }
	);
	return res.data;
}

// Simple global cache + listeners
// Default thresholds until explicitly set: green=70%, red=90%
let cache = { battery_low_threshold_v: 11, fill_green_threshold_pct: 70, fill_yellow_threshold_pct: undefined, fill_red_threshold_pct: 90 };
const listeners = new Set();
export function getCachedThresholds(){ return { ...cache }; }
export function subscribeThresholds(fn){ listeners.add(fn); return () => listeners.delete(fn); }
export async function refreshThresholds(){
	const data = await getTelemetryThresholds();
	const normalized = {
		battery_low_threshold_v: data.battery_low_threshold_v != null ? Number(parseFloat(data.battery_low_threshold_v).toFixed(1)) : cache.battery_low_threshold_v,
		fill_green_threshold_pct: data.fill_green_threshold_pct != null ? Number(data.fill_green_threshold_pct) : cache.fill_green_threshold_pct,
		// yellow is implicit: between green upper and red lower; no separate cache key needed
		fill_red_threshold_pct: data.fill_red_threshold_pct != null ? Number(data.fill_red_threshold_pct) : cache.fill_red_threshold_pct,
	};
	cache = { ...cache, ...normalized };
	listeners.forEach(fn => { try{ fn(cache); } catch{} });
	return cache;
}

const API_URL = '/api/settings';

const getLanguage = () => axios.get(`${API_URL}/language`, { headers: authHeader() });

const updateLanguage = (language) => axios.put(`${API_URL}/language`, { language }, { headers: authHeader() });

const settingsService = { getLanguage, updateLanguage };
export default settingsService;
